export default {
    declarations: {
        vegetation_type: {
            old: 'Obligations légales de débroussaillement',
            forest: 'Gestion forestière',
            other: 'Autres résidus végétaux issus de parcelles agricoles',
            culture: 'Culture',
        },
        declaration_type_id: 'Type de demande',
        declaration_types: {
            index: '',
            id: 'Type de demande',
        },
        declaration_type: {
            index: 'Type de demande',
            name: 'Type de demande',
        },
    },
}
